const UpdateIcon = ({ size = 16, color = "currentColor" }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 4C14.134 4 16.087 4.834 17.536 6.196L18.5 5.232C18.814 4.918 19.351 5.14 19.351 5.585V9.351C19.351 9.627 19.127 9.851 18.851 9.851H15.085C14.639 9.851 14.418 9.314 14.732 9L15.787 7.945C14.773 7.028 13.431 6.5 12 6.5C8.962 6.5 6.5 8.962 6.5 12H4C4 7.582 7.582 4 12 4Z"
				fill={color}
			/>
			<path
				d="M12 20C9.866 20 7.913 19.166 6.464 17.804L5.5 18.768C5.186 19.082 4.649 18.86 4.649 18.415V14.649C4.649 14.373 4.873 14.149 5.149 14.149H8.915C9.361 14.149 9.582 14.686 9.268 15L8.213 16.055C9.227 16.972 10.569 17.5 12 17.5C15.038 17.5 17.5 15.038 17.5 12H20C20 16.418 16.418 20 12 20Z"
				fill={color}
			/>
		</svg>
	);
};

export default UpdateIcon;
